import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { get, getWithParams } from "../../utils/fetchAPI";

const initialState = {
  dashboardAppointments: [],
  allAppointmentsCount: [],
  barChartAppointment: [],
  clinicStats: null,
  organizationInsights: null,
  todaySummary: null,
  isLoading: false,
  /** Bar chart only (daily appointments); avoids clashing with list/other thunks */
  isBarChartLoading: false,
  isOperationLoading: false,
  isOrgInsightsLoading: false,
  isTodaySummaryLoading: false,
  error: null,
  noPatientFound: false,
};
export const getDashboardAppointments = createAsyncThunk(
  "dashboard/getDashboardAppointments",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getWithParams(`/dashboard/latest-appointments`,payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBarChartAppointment = createAsyncThunk(
  "dashboard/getBarChartAppointment",
  async (userRoleId, { rejectWithValue }) => {
    try {
      const response = await getWithParams(`/dashboard/daily-appointments`,{userRoleId:userRoleId});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllAppointmentCount = createAsyncThunk(
  "dashboard/getAllAppointmentCount",
  async (userRoleId, { rejectWithValue }) => {
    try {
      const response = await getWithParams(`/dashboard/appointments-by-status`,{userRoleId:userRoleId});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getClinicStats = createAsyncThunk(
  "dashboard/getClinicStats",
  async ({ userRoleId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await getWithParams(`/dashboard/clinic-stats`, {
        userRoleId,
        startDate,
        endDate,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getOrganizationInsights = createAsyncThunk(
  "dashboard/getOrganizationInsights",
  async (userRoleId, { rejectWithValue }) => {
    try {
      const response = await getWithParams(`/dashboard/organization-insights`, {
        userRoleId,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getDoctorTodaySummary = createAsyncThunk(
  "dashboard/getDoctorTodaySummary",
  async ({ userRoleId, doctorId, date }, { rejectWithValue }) => {
    try {
      const response = await getWithParams(`/dashboard/doctor-today-summary`, {
        userRoleId,
        doctorId,
        date,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetAllPatients: (state, action) => {

    },
  },
  extraReducers: {
    [getDashboardAppointments.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    [getDashboardAppointments.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.dashboardAppointments = action.payload;
      state.error = null;
    },
    [getDashboardAppointments.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.message;
    },

    [getBarChartAppointment.pending]: (state) => {
      state.isBarChartLoading = true;
      state.error = null;
    },
    [getBarChartAppointment.fulfilled]: (state, action) => {
      state.isBarChartLoading = false;
      state.barChartAppointment = action.payload;
      state.error = null;
    },
    [getBarChartAppointment.rejected]: (state, action) => {
      state.isBarChartLoading = false;
      state.error = action.payload?.message;
    },

    [getAllAppointmentCount.fulfilled]: (state, action) => {
      state.allAppointmentsCount = action.payload;
      state.error = null;
    },
    [getAllAppointmentCount.rejected]: (state, action) => {
      state.error = action.payload?.message;
    },

    [getClinicStats.pending]: (state) => {
      state.isOperationLoading = true;
      state.error = null;
    },
    [getClinicStats.fulfilled]: (state, action) => {
      state.isOperationLoading = false;
      state.clinicStats = action.payload;
      state.error = null;
    },
    [getClinicStats.rejected]: (state, action) => {
      state.isOperationLoading = false;
      state.error =
        action.payload?.errors?.[0]?.msg ||
        action.payload?.message ||
        "Failed to load clinic stats";
    },

    [getOrganizationInsights.pending]: (state) => {
      state.isOrgInsightsLoading = true;
    },
    [getOrganizationInsights.fulfilled]: (state, action) => {
      state.isOrgInsightsLoading = false;
      state.organizationInsights = action.payload;
    },
    [getOrganizationInsights.rejected]: (state) => {
      state.isOrgInsightsLoading = false;
      state.organizationInsights = null;
    },

    [getDoctorTodaySummary.pending]: (state) => {
      state.isTodaySummaryLoading = true;
      state.error = null;
    },
    [getDoctorTodaySummary.fulfilled]: (state, action) => {
      state.isTodaySummaryLoading = false;
      state.todaySummary = action.payload;
      state.error = null;
    },
    [getDoctorTodaySummary.rejected]: (state, action) => {
      state.isTodaySummaryLoading = false;
      state.todaySummary = null;
      state.error =
        action.payload?.errors?.[0]?.msg ||
        action.payload?.message ||
        "Failed to load today summary";
    },
  },
});

export default dashboardSlice.reducer;
// export const { resetAllPatients } = patientSlice.actions;
